import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(11.000000, 5.000000)">
  {/*<path
          d="M 40.1 70 L 9 12.2 L 9 70 L 0 70 L 0 0 L 12.6 0 L 43.5 58.2 L 43.5 0 L 52.5 0 L 52.5 70 L 40.1 70 Z M 70.5 70 L 70.5 0 L 112 0 L 112 8.2 L 80 8.2 L 80 29.6 L 106.7 29.6 L 106.7 37.4 L 80 37.4 L 80 70 L 70.5 70 Z"
          fill="currentColor"
        />*/}
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
